<div class="spinner-wrapper" *ngIf="showLoader">
  <mat-spinner></mat-spinner>
</div>
<div class="container design-overview-wrapper">
  <h2>View Equipment</h2>
  <hr>
  <div class="breadcrumb">
    <ul class="d-flex align-items-center breadcrumb__list">
      <li class="breadcrumb__list__list-item"><a class="breadcrumb__list__list-item__link" routerLink="/home">Home</a>
      </li>
      <li class="breadcrumb__list__list-item"><a class="breadcrumb__list__list-item__link"
          routerLink="/equipment">Equipment</a>
      </li>
      <li class="breadcrumb__list__list-item"><a
          class="breadcrumb__list__list-item__link">{{equipment?.equipmentname}}</a>
      </li>
    </ul>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="col-md-6 col-12">
      <p class="design-overview-wrapper__item__title mb-0"> Equipment Name <i style="color:red;">*</i></p>
      <p class="design-overview-wrapper__item__detail mb-3">{{equipment?.equipmentname}}
      </p>
      <p class="design-overview-wrapper__item__title mb-0">Equipment Description</p>
      <p class="design-overview-wrapper__item__detail mb-3"> {{equipment?.equipmentdescription}}
      </p>
    </div>
    <div class="design-overview-wrapper__item">
      <div class="d-flex">
        <div class="pe-3">
          <span class="design-overview-wrapper__item__item-number">
            4
          </span>
        </div>
        <div class="ps-3">
          <p class="design-overview-wrapper__item__title">Air Conditioner / Heat Pump, if too be installed</p>
          <p class="design-overview-wrapper__item__detail"></p>
        </div>
      </div>
    </div>
    <div class="design-overview-wrapper__item">
      <div class="d-flex">
        <div class="pe-3">
          <span class="design-overview-wrapper__item__item-number">
            4.2
          </span>
        </div>
        <div class="ps-3">
          <p class="design-overview-wrapper__item__title">Equipment Type</p>
          <p class="design-overview-wrapper__item__detail"> {{equipment?.equiptype}}

          </p>
        </div>
      </div>
    </div>
    <div class="d-flex flex-wrap">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          4.3
        </span>
      </div>
      <div class="ps-3 flex-grow-1">
        <div class="d-flex flex-wrap">
          <div class="col-md-6 col-12">
            <p class="design-overview-wrapper__item__title mb-0">Condenser Manufacturer
            </p>
            <p class="design-overview-wrapper__item__detail mb-3"> {{equipment?.condmfr}}
            </p>
          </div>
          <div class="col-md-6 col-12">
            <p class="design-overview-wrapper__item__title mb-0">Condenser Model Number
            </p>
            <p class="design-overview-wrapper__item__detail mb-3"> {{equipment?.condensermn}}

            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex flex-wrap">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          4.4
        </span>
      </div>
      <div class="ps-3 flex-grow-1">
        <div class="d-flex flex-wrap">
          <div class="col-md-6 col-12">
            <p class="design-overview-wrapper__item__title mb-0">Evaporator Manufacturer
            </p>
            <p class="design-overview-wrapper__item__detail mb-3"> {{ equipment?.evapmfr}}
            </p>
          </div>
          <div class="col-md-6 col-12">
            <p class="design-overview-wrapper__item__title mb-0">Evaporator Model Number
            </p>
            <p class="design-overview-wrapper__item__detail mb-3"> {{equipment?.evapmn}}

            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="design-overview-wrapper__item">
      <div class="d-flex">
        <div class="pe-3">
          <span class="design-overview-wrapper__item__item-number">
            4.5
          </span>
        </div>
        <div class="ps-3">
          <p class="design-overview-wrapper__item__title">AHRI Reference
          </p>
          <p class="design-overview-wrapper__item__detail"> {{equipment?.ahrino}}</p>
        </div>
      </div>
    </div>
    <div class="d-flex flex-wrap">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          4.6
        </span>
      </div>
      <div class="ps-3 flex-grow-1">
        <div class="d-flex flex-wrap">
          <div class="col-md-6 col-12">
            <p class="design-overview-wrapper__item__title mb-0">EER</p>
            <p class="design-overview-wrapper__item__detail mb-3"> {{equipment?.listedeer}}
            </p>
          </div>
          <div class="col-md-6 col-12">
            <p class="design-overview-wrapper__item__title mb-0">SEER</p>
            <p class="design-overview-wrapper__item__detail mb-3"> {{ equipment?.listedseer}}
            </p>
          </div>
          <div class="col-md-6 col-12">
            <p class="design-overview-wrapper__item__title mb-0">COP</p>
            <p class="design-overview-wrapper__item__detail mb-3"> {{ equipment?.hp17fcop}}
            </p>
          </div>
          <div class="col-md-6 col-12">
            <p class="design-overview-wrapper__item__title mb-0">HSPF</p>
            <p class="design-overview-wrapper__item__detail mb-3"> {{ equipment?.hpahrilistedhpsf}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          4.7
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title">Evaporator FanType
        </p>
        <p class="design-overview-wrapper__item__detail"> {{equipment?.fanspeed}}
        </p>
      </div>
    </div>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          4.8
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title">Compressor Type
        </p>
        <p class="design-overview-wrapper__item__detail"> {{equipment?.compressortype}}
        </p>
      </div>
    </div>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          4.9
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title">Listed System Latent Capacity at Design Condition
        </p>
        <p class="design-overview-wrapper__item__detail"> {{equipment?.latentdescap}}(kBtuh)
        </p>
      </div>
    </div>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          4.10
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title">Listed System Sensible Capacity at Design Condition
        </p>
        <p class="design-overview-wrapper__item__detail"> {{equipment?.sensibledescap}}(kBtuh)

        </p>
      </div>
    </div>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          4.11
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title">Listed System Total Capacity at Design Condition
        </p>
        <p class="design-overview-wrapper__item__detail"> {{ equipment?.totaldescap}} (kBtuh)

        </p>
      </div>
    </div>
  </div>
  <div class="d-flex flex-wrap">
    <div class="pe-3">
      <span class="design-overview-wrapper__item__item-number">
        4.12
      </span>
    </div>
    <div class="ps-3 flex-grow-1">
      <div class="d-flex flex-wrap">
        <div class="col-md-6 col-12">
          <p class="design-overview-wrapper__item__title mb-0">Performance at 17F:
          </p>
          <p class="design-overview-wrapper__item__detail mb-3">Capacity</p>
          <p class="design-overview-wrapper__item__detail mb-3"> {{equipment?.hp17fcap}}(kBtuh)

          </p>
        </div>
        <div class="col-md-6 col-12">
          <p class="design-overview-wrapper__item__title mb-0">Performance at 47F:
          </p>
          <p class="design-overview-wrapper__item__detail mb-3">Capacity</p>
          <p class="design-overview-wrapper__item__detail mb-3"> {{ equipment?.hp47fcap}}(BTUh)

          </p>
        </div>
      </div>
    </div>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          4.14
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title">Listed System Total Capacity at Design Condition
        </p>
        <p class="design-overview-wrapper__item__detail"> {{equipment?.cddratio}}

        </p>
        <p class="design-overview-wrapper__item__detail">Ratio
        </p>
        <p class="design-overview-wrapper__item__detail"> {{equipment?.ratercompid}}

        </p>
      </div>
    </div>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex">

      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          4.17
        </span>
      </div>
      <div class="ps-3 flex-grow-1">
        <div class="d-flex flex-wrap">
          <div class="col-md-6 col-12">
            <p class="design-overview-wrapper__item__title mb-0">Furnace Manufacturer

            </p>
            <p class="design-overview-wrapper__item__detail mb-0">{{equipment?.furnmfre}}

            </p>
          </div>
          <div class="col-md-6 col-12">
            <p class="design-overview-wrapper__item__title mb-0">Furnace Manufacturer Number
            </p>
            <p class="design-overview-wrapper__item__detail mb-0">{{equipment?.furnacemn}}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          4.18
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title">Listed Efficiency: (AFUE)

        </p>
        <p class="design-overview-wrapper__item__detail">
          {{equipment?.listedafue}}
        </p>
      </div>
    </div>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="pe-3">
        <span class="design-overview-wrapper__item__item-number">
          4.19
        </span>
      </div>
      <div class="ps-3">
        <p class="design-overview-wrapper__item__title">Listed Output Heating Capacity :
        </p>
        <p class="design-overview-wrapper__item__detail"> {{equipment?.furnoutput}}kBtuh
        </p>
      </div>
    </div>
  </div>
  <div class="design-overview-wrapper__item">
    <div class="d-flex">
      <div class="ps-3">
        <p class="design-overview-wrapper__item__detail" style="color:red;">* Required fields
        </p>
      </div>
    </div>
  </div>

  <div class="row col-8 center-block dashboard-btn-row">
    <div class="d-flex my-3">
      <button mat-flat-button color="primary" class="me-3" [routerLink]="['/equipment-form']"
        [queryParams]="{id: equipment?.equipment_id}">EDIT</button>
      <button mat-flat-button class="me-3" color="warn" type="button" data-toggle="collapse" data-target="#dds3"
        (click)="delete(equipment.equipment_id)" aria-expanded="false" aria-controls="dds3">
        DELETE
      </button>
      <button mat-flat-button color="basic" type="button" [routerLink]="['/equipment']" data-toggle="collapse"
      data-target="#dds3" aria-expanded="false" aria-controls="dds3">
      Back
    </button>
    </div>

  </div>

</div>